export const DIGITAL_LOAN_STEPS = Object.freeze({
  INTRO: 'intro',
  PERMISSIONS: 'permissions',
  LOCATION: 'location',
  APPLICABILITY_LOAN: 'applicability-loan',
  APPLICABILITY_ADDRESS: 'applicability-address',
  APPLICABILITY_IDENTITY: 'applicability-identity',
  // Phase 2 (prenda / pre-oferta)
  GUARANTEE_AVAILABILITY: 'guarantee-availability',
  GUARANTEE_FAMILY: 'guarantee-family',
  GUARANTEE_SUBFAMILY: 'guarantee-subfamily',
  GUARANTEE_ARTICLE: 'guarantee-article',
  GUARANTEE_BRAND: 'guarantee-brand',
  GUARANTEE_MODEL: 'guarantee-model',
  PHOTO_REQUIREMENTS: 'photo-requirements',
  PHOTO_CAPTURE: 'photo-capture',
  PHOTO_REVIEW: 'photo-review',
  VALIDATION_FAILED: 'validation-failed',
  INSUFFICIENT_VALUE: 'insufficient-value',
  MISSING_ONBOARDING: 'missing-onboarding',
  NOT_PREAPPROVED: 'not-preapproved',
  PRE_OFFER: 'pre-offer',
  VISIT_STATUS: 'visit-status',
  FINAL_OFFER: 'final-offer',
  CLABE: 'clabe',
  BIOMETRIC_FINAL: 'biometric-final',
  CONTRACT_GENERATION: 'contract-generation',
  OPERATIONAL_WINDOW: 'operational-window',
  CONTRACT_READY: 'contract-ready',
});

export const DIGITAL_LOAN_STEP_ORDER = Object.freeze([
  DIGITAL_LOAN_STEPS.INTRO,
  DIGITAL_LOAN_STEPS.PERMISSIONS,
  DIGITAL_LOAN_STEPS.LOCATION,
  DIGITAL_LOAN_STEPS.APPLICABILITY_LOAN,
  DIGITAL_LOAN_STEPS.APPLICABILITY_ADDRESS,
  DIGITAL_LOAN_STEPS.APPLICABILITY_IDENTITY,
  DIGITAL_LOAN_STEPS.GUARANTEE_AVAILABILITY,
  DIGITAL_LOAN_STEPS.GUARANTEE_FAMILY,
  DIGITAL_LOAN_STEPS.GUARANTEE_SUBFAMILY,
  DIGITAL_LOAN_STEPS.GUARANTEE_ARTICLE,
  DIGITAL_LOAN_STEPS.GUARANTEE_BRAND,
  DIGITAL_LOAN_STEPS.GUARANTEE_MODEL,
  DIGITAL_LOAN_STEPS.PHOTO_REQUIREMENTS,
  DIGITAL_LOAN_STEPS.PHOTO_CAPTURE,
  DIGITAL_LOAN_STEPS.PHOTO_REVIEW,
  DIGITAL_LOAN_STEPS.VALIDATION_FAILED,
  DIGITAL_LOAN_STEPS.INSUFFICIENT_VALUE,
  DIGITAL_LOAN_STEPS.MISSING_ONBOARDING,
  DIGITAL_LOAN_STEPS.NOT_PREAPPROVED,
  DIGITAL_LOAN_STEPS.PRE_OFFER,
  DIGITAL_LOAN_STEPS.VISIT_STATUS,
  DIGITAL_LOAN_STEPS.FINAL_OFFER,
  DIGITAL_LOAN_STEPS.CLABE,
  DIGITAL_LOAN_STEPS.BIOMETRIC_FINAL,
  DIGITAL_LOAN_STEPS.CONTRACT_GENERATION,
  DIGITAL_LOAN_STEPS.OPERATIONAL_WINDOW,
  DIGITAL_LOAN_STEPS.CONTRACT_READY,
]);

export const LOCATION_OPTIONS = Object.freeze({
  LIVE_NEARBY: 'live_nearby',
  WORK_NEARBY: 'work_nearby',
  BUSINESS_NEARBY: 'business_nearby',
  UNSURE: 'unsure',
});

export const PAYMENT_FREQUENCIES = Object.freeze({
  BIWEEKLY: 'biweekly',
  MONTHLY: 'monthly',
});

export const DIGITAL_LOAN_FLOW_STATUS = Object.freeze({
  IDLE: 'idle',
  LOCATION_VALIDATED: 'location_validated',
});

export const REJECTION_TYPES = Object.freeze({
  BLACKLIST: 'blacklist',
  LOCATION: 'location',
  APPLICABILITY: 'applicability',
});

export const BIOMETRIC_FAILURE_TIMEOUT_MS = 5000;

/** Query param de desarrollo: success | failure (solo en NODE_ENV !== production). */
export const DEV_BIOMETRIC_QUERY_KEY = 'digitalLoanBiometric';

/** Query param de desarrollo: error fuerza rechazo de aplicabilidad (staging mocks). */
export const DEV_APPLICABILITY_QUERY_KEY = 'digitalLoanApplicability';
